module.exports = __webpack_public_path__ + "static/media/show2.2f46b1dd.png";